module.exports = {"371626001":"黛溪街道","371626002":"黄山街道","371626003":"高新街道","371626004":"好生街道","371626005":"西董街道","371626101":"长山镇","371626102":"魏桥镇","371626105":"临池镇","371626108":"焦桥镇","371626109":"韩店镇","371626110":"孙镇镇","371626111":"九户镇","371626112":"青阳镇","371626113":"明集镇","371626114":"台子镇","371626115":"码头镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371626.json
// module id = 1499
// module chunks = 0